import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export const controlClassName = 'w-full min-w-0 rounded-lg border border-input bg-card px-3 text-base text-foreground shadow-[0_1px_1px_rgb(16_24_40/0.03)] transition-[color,box-shadow,border-color] outline-none placeholder:text-muted-foreground/75 hover:border-[#BCC4CF] focus-visible:border-primary focus-visible:ring-3 focus-visible:ring-ring/12 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/15 sm:text-sm'

function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
    return (
        <input
            type={type}
            data-slot='input'
            className={cn(controlClassName, 'h-11 sm:h-10', className)}
            {...props}
        />
    )
}

export { Input }
